import _definePage_default_0 from '/repo/apps/admin/src/pages/login.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/repo/apps/admin/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/repo/apps/admin/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/audit',
    name: '/audit',
    component: () => import('/repo/apps/admin/src/pages/audit.vue'),
    /* no children */
  },
  {
    path: '/content',
    name: '/content',
    component: () => import('/repo/apps/admin/src/pages/content.vue'),
    /* no children */
  },
  {
    path: '/leads',
    /* internal name: '/leads' */
    /* no component */
    children: [
      {
        path: '',
        name: '/leads/',
        component: () => import('/repo/apps/admin/src/pages/leads/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/leads/[id]',
        component: () => import('/repo/apps/admin/src/pages/leads/[id].vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: '/login',
    component: () => import('/repo/apps/admin/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/repo/apps/admin/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/users',
    name: '/users',
    component: () => import('/repo/apps/admin/src/pages/users.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

